import { Menu, Tooltip } from '@mantine/core'

import StyledBadge from 'src/components/DataDisplay/StyledBadge/StyledBadge'
import {
  MenuChevron,
  TASK_MENU_CLASSNAMES,
} from 'src/components/Shared/TaskMenus/taskMenuStyles'
import { TaskStatus } from 'src/graphql/types/tasks'
import { formatSnakeValue } from 'src/lib/formatters'
import { STATUS_BADGE_COLOR } from 'src/lib/taskStatus'

const StatusMenu = ({ status, setStatus }) => {
  return (
    <Menu
      offset={6}
      width={185}
      position="bottom-end"
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Tooltip label={'Change status'} position="top" className="text-xs">
        <Menu.Target>
          <div
            data-testid="status-menu-trigger"
            className="flex cursor-pointer items-center gap-1"
          >
            <StyledBadge
              size="xs"
              clickable
              textTransform="capitalize"
              color={STATUS_BADGE_COLOR[status] ?? 'gray'}
            >
              {formatSnakeValue(status)}
            </StyledBadge>
            <MenuChevron />
          </div>
        </Menu.Target>
      </Tooltip>

      <Menu.Dropdown>
        {Object.values(TaskStatus).map((value) => (
          <Menu.Item key={value} onClick={() => setStatus(value)}>
            {formatSnakeValue(value)}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default StatusMenu
